module.exports = "/_next/static/images/UseSegment@2x-45ce8bcb78d4644a5dc1402dac3e1100.webp";